import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { FiltrarListarDocumentosAssinatura } from '../../../../models/filtro-listar-documentos.model';
import { AssinarDocumentoService } from '../../../../services/assinar-documento.service';
import { DocumentoContrato, ListaDocumentoAssinatura, Totalizador } from '../../../../models/lista-documento-assinatura.mode';
import { debounceTime } from 'rxjs';
import { PaginationDto } from 'src/app/core/dto/pagination.dto';

@Component({
  selector: 'app-documento-assinatura',
  templateUrl: './documento-assinatura.component.html',
  styleUrl: './documento-assinatura.component.scss'
})
export class DocumentoAssinaturaComponent implements OnInit {
  breadCrumbItems!: Array<{}>;

  documentosAssinaturas: DocumentoContrato[] = [];

  isLoading = false;
  filtroForm: FormGroup;

  qtddStatusCancelado = 0;
  atddStatusFinalizado = 0;
  qtddStatusAguardandoSignatario = 0;
  atddStatusAguardandoAssinatura = 0;

  paginacao: PaginationDto = {
    paginaAtual: 1,
    quantidadePorPagina: 10,
    totalDeItens: 0,
    ultimaPagina: 0,
  };

  constructor(
    private fb: FormBuilder,
    public assinarDocumentoService: AssinarDocumentoService) {

    this.filtroForm = this.fb.group({
      "PaginaAtual": [1],
      "QuantidadePorPagina": [10],
      ano: [new Date().getFullYear()]
    })

  }

  ngOnInit(): void {

    this.breadCrumbItems = [
      { label: "Projetos" },
      { label: "Todos Documentos", active: true }
    ];

    this.consultarListarDocumentosAssinatura(this.filtroForm.value);
    this.filtroForm.valueChanges
      .pipe(debounceTime(600))
      .subscribe((filters) => {
        this.consultarListarDocumentosAssinatura(filters)
      })
  }

  consultarListarDocumentosAssinatura(filtros: FiltrarListarDocumentosAssinatura) {
    this.isLoading = true;
    this.assinarDocumentoService
      .consultarDocumentosTotalizadores(filtros)
      .subscribe({
        next: (response: ListaDocumentoAssinatura) => {
          this.documentosAssinaturas = response.documentos;
          this.paginacao = response.paginacao;
          this.separarStatusParaApresentar(response.totalizadores);
        },
        error: (error) => {

        },
        complete: () => {
          this.isLoading = false;
        }
      })
  }

  separarStatusParaApresentar(totalizadores: Totalizador[]) {
    if (!totalizadores || totalizadores.length === 0) {
      this.qtddStatusCancelado = 0;
      this.atddStatusFinalizado = 0;
      this.qtddStatusAguardandoSignatario = 0;
      this.atddStatusAguardandoAssinatura = 0;
      return;
    }

    totalizadores.forEach(t => {
      const status = t.descricaoStatus?.toLowerCase().trim();
      switch (status) {
        case 'cancelado':
          this.qtddStatusCancelado = t.quantidade;
          break;
        case 'finalizado':
          this.atddStatusFinalizado = t.quantidade;
          break;
        case 'aguardando signatários':
          this.qtddStatusAguardandoSignatario = t.quantidade;
          break;
        case 'aguardando assinaturas':
          this.atddStatusAguardandoAssinatura = t.quantidade;
          break;
        case 'processando':
          this.atddStatusAguardandoAssinatura = t.quantidade;
          break;

        // case 'editando':
        //   this.qtddStatusAgendamento = t.quantidade;
        //   break;
      }
    });
  }

  onPageChange(page: number) {
    this.filtroForm.patchValue({
      "PaginaAtual": page,
    });
  }
}
